import fetch from './index';

// 获取模块
const getModule = () => fetch.axios_admin.get('/module/tree');

// 添加模块
const addMoudle = (data: any) => fetch.axios_admin.post('/module', data);

// 修改模块
const editMoudle = (data: any) => fetch.axios_admin.put('/module', data);

// 删除模块
const removeModule = (id: string) => fetch.axios_admin.remove(`/module/${id}`);

export default {
  getModule,
  addMoudle,
  editMoudle,
  removeModule,
};
